import { render, staticRenderFns } from "./infografis.vue?vue&type=template&id=863b3fa4&scoped=true&"
import script from "./infografis.vue?vue&type=script&lang=js&"
export * from "./infografis.vue?vue&type=script&lang=js&"
import style0 from "./infografis.vue?vue&type=style&index=0&id=863b3fa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863b3fa4",
  null
  
)

export default component.exports